import type { FileRenderControl } from "./FileRender";
import { ToggleButton, ToggleIcon, ToggleIconContainer } from "./HeadingToggle";
import { Icon } from "./Icon";
import { Tooltip } from "./Tooltip";

const iconShown = { opacity: 1, transform: "rotate(0deg) scale(1)" };
const iconHiddenCw = { opacity: 0, transform: "rotate(90deg) scale(0.5)" };
const iconHiddenCcw = { opacity: 0, transform: "rotate(-90deg) scale(0.5)" };

export function FileRenderControlButton({
  control,
}: {
  control: FileRenderControl;
}) {
  return (
    <Tooltip content={control.label}>
      <ToggleButton
        onPress={control.onToggle}
        aria-label={control.label}
        aria-pressed={control.active}
        disabled={control.disabled}
        data-icon-crossfade={control.activeIcon ? true : undefined}
      >
        {control.activeIcon ? (
          <ToggleIconContainer>
            <ToggleIcon style={control.active ? iconHiddenCw : iconShown}>
              <Icon name={control.icon} size={12} />
            </ToggleIcon>
            <ToggleIcon style={control.active ? iconShown : iconHiddenCcw}>
              <Icon name={control.activeIcon} size={12} />
            </ToggleIcon>
          </ToggleIconContainer>
        ) : (
          <Icon name={control.icon} size={12} />
        )}
      </ToggleButton>
    </Tooltip>
  );
}
